var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-alert',{attrs:{"type":"warning","border":"left","outlined":""}},[_c('p',{staticClass:"font-weight-bold mb-0"},[_vm._v("Atenção")]),_c('p',{staticClass:"mb-0"},[_vm._v("Nenhum plano selecionado")])])}
var staticRenderFns = []

export { render, staticRenderFns }